import Link from 'next/link';
import Image from 'next/image';

const Logo = () => {
  return (
    <>
      <Link href='/'>
        <Image
          src='/images/Design-Series-Logo-60h.svg'
          width={200}
          height={28}
          alt='Designer Series Logo'
          className='cursor-pointer'
          unoptimized
          priority
        ></Image>
      </Link>
    </>
  );
};

export default Logo;
